
function DateField() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
		controller: function($parse) {
			var self = this;
			
			this.opened = false;
			this.dateOptions = {
				//closeOnDateSelection: true,
				//locale:{firstDay:1}
				startingDay: 1
			}
			
			this.open = function($event) {
				$event.preventDefault();
				$event.stopPropagation();
				this.opened = true;
			};
			
			this.isDisabledFunc = null;
			
			this.isDisabled = function(date, mode) {
				if (self.field.client && self.field.client.isDisabled) {
					if (!this.isDisabledFunc) {
						this.isDisabledFunc = $parse(self.field.client.isDisabled);
					}
					return this.isDisabledFunc(self.object, {date:date, mode:mode, moment:window.moment})
				}
				return false;
			}
			
			this.minDate = function() {
				if (self.field.client && self.field.client.minDate) {
					var func = $parse(self.field.client.minDate);
					return func(self.object, {moment:window.moment});
				}
				return null;
			}
			
			this.maxDate = function() {
				if (self.field.client && self.field.client.maxDate) {
					var func = $parse(self.field.client.maxDate);
					return func(self.object, {moment:window.moment});
				}
				return null;
			}

		},
		controllerAs: '$date'
	}
}


function DateController($scope, $parse) {

	var self = this;
	this.opened = false;
	this.dateOptions = {
		//closeOnDateSelection: true,
		//locale:{firstDay:1}
		startingDay: 1
	}
	
	this.open = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      this.opened = true;
    };
	
	this.isDisabledFunc = null;
	
	this.isDisabled = function(date, mode, field) {
		if (field.client && field.client.isDisabled) {
			if (!this.isDisabledFunc) {
				this.isDisabledFunc = $parse(field.client.isDisabled);
			}
			return this.isDisabledFunc($scope.object, {date:date, mode:mode, moment:window.moment})
		}
		return false;
	}
	
	this.minDate = function(field) {
		if (field.client && field.client.minDate) {
			var func = $parse(field.client.minDate);
			return func($scope.object, {moment:window.moment});
		}
		return null;
	}
	
	this.maxDate = function(field) {
		if (field.client && field.client.maxDate) {
			var func = $parse(field.client.maxDate);
			return func($scope.object, {moment:window.moment});
		}
		return null;
	}

	window.dCtrl = this;
}


function datepickerTextModel() {
	return {
		require: 'ngModel',
		link: function (scope, elem, attrs, ngModel) {
			var format = attrs.datepickerTextModel || "YYYY-MM-DD";

			ngModel.$formatters.push(function(value){
				if (!value) return null;
				var m = moment(value, format);
				return m.isValid()? m.toDate() : null;
			});
			
			ngModel.$parsers.push(function(value){
				if (value) {
					return moment(value).format(format);
				} else {
					return null;
				}
			});
		}
		
	}
}

function datetimepickerTextModel() {
	return {
		require: 'ngModel',
		link: function (scope, elem, attrs, ngModel) {
			ngModel.$formatters.push(function(value){
				if (!value) return null;
				var m = moment(value);
				return m.isValid()? m.toDate() : null;
			});
			
			ngModel.$parsers.push(function(value){
				if (value) {
					return moment(value).format("YYYY-MM-DD HH:mm:ss");
				} else {
					return null;
				}
			});
		}
		
	}
}

angular.module('forms.fields.date', [])
.controller('DateController', DateController)
.directive('datepickerTextModel', datepickerTextModel)
.directive('datetimepickerTextModel', datetimepickerTextModel)
.directive('dateField', DateField)
